import { Html, useProgress } from "@react-three/drei";
import { FaSpinner } from "react-icons/fa";

export const CanvasLoader = () => {
  const { progress } = useProgress();
  return (
    <Html
      as="div"
      center
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <span className="canvas-loader"></span>
      <p
        style={{
          fontSize: 14,
          color: "var(--color-foreground)",
          fontWeight: 800,
          marginTop: 40,
        }}
      >
        {progress.toFixed(2)}%
      </p>
    </Html>
  );
};

export const ImageLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
      }}
    >
      <FaSpinner className="flex justify-center content-center h-100 animate-spin text-blue-500" />
    </div>
  );
};
